module.exports = __webpack_public_path__ + "603be726f4c559edd256bc080c25f172.svg";